export const ID_ACCESSORIES = 'ACCESSORIES';
export const ID_FUEL = "FUEL";
export const ID_COMMISSIONS ="COMMISSIONS";
export const ID_TRANSFERS = "TRANSFERS";
export const ID_DAMAGE ="DAMAGE";
export const ID_JLR = "JLR";
export const ID_BE_FREE_EVO = "BE_FREE_EVO";
export const ID_CAR_CLOUD = "CAR_CLOUD";
export const ID_CAR_BOX = "CAR_BOX";
export const ID_FLEX_RENT = "FLEX_RENT";
export const ID_VOUCHERS = "VOUCHERS";
export const ID_DAMAGE_SHEET ="DAMAGE_SHEET";